import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Alert,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Box,
  Typography,
  DialogContentText,
  DialogActions,
  Autocomplete,
} from "@mui/material";
import moment from "moment";
//enviar mails
import { grey } from "@mui/material/colors";
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR IMAGEN
import Notify from "../../Notify";
import { getData } from "../../../services/library";
import { UrlApi } from "../../../services/apirest";
import { enviarmails } from "../../../services/services";

const SucursalesSeleccionadasList = React.memo(
  ({ sucursalesFiltradas, handleEliminarSucursal, fichas }) =>
    sucursalesFiltradas.map((sucursal, index) => {
      const cantidadFichas = fichas
        ? fichas.filter((f) => f.sucursal === sucursal.id).length
        : 0;

      return (
        <Box
          key={`${sucursal.id}-${index}`}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Typography fontSize={16}>
            {sucursal.id} - {sucursal.nombre}
            <Typography
              component="span"
              sx={{
                ml: 1,
                color: cantidadFichas > 0 ? "success.main" : "text.secondary",
                fontWeight: cantidadFichas > 0 ? "bold" : "normal",
              }}
            >
              ({cantidadFichas} {cantidadFichas === 1 ? "ficha" : "fichas"})
            </Typography>
          </Typography>
          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={() => handleEliminarSucursal(index)}
          >
            Eliminar
          </Button>
        </Box>
      );
    })
);

function ModalEnviarPdf(props) {
  const [enviar, setEnviar] = useState(props.enviar);
  const [disabled, setdisabled] = useState(false)
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const style = { backgroundColor: "#ffffff", width: "100%" };
  const hoy = new Date();
  const haceUnAnio = new Date();
  haceUnAnio.setFullYear(hoy.getFullYear() - 1);
  const [desde, setDesde] = useState(haceUnAnio.toISOString().split("T")[0]);
  const [hasta, setHasta] = useState(hoy.toISOString().split("T")[0]);
  const [sucursales, setSucursales] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [sucursalesSeleccionadas, setSucursalesSeleccionadas] = useState([]);
  const [filtrando, setFiltrando] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [fichas, setfichas] = useState();
  const obtenerSucursales = () => {
    getData("/sucursales", setSucursales);
  };
  const obtenerFichas = () => {
    getData(
      "/stock_ficha_rrhh/fichasxempfecha/" + desde + "/" + hasta,
      setfichas
    );
  };

  useEffect(() => {
    obtenerSucursales();
    obtenerFichas();
  }, []);

  const handleSucursalSeleccionada = useCallback(
    (value) => {
      if (
        value &&
        !sucursalesSeleccionadas.some((emp) => emp.id === value.id)
      ) {
        setSucursalesSeleccionadas((prev) => [...prev, value]);
        setSucursalSeleccionada(null);
      }
      setFiltrando(false);
    },
    [sucursalesSeleccionadas]
  );

  const handleEliminarSucursal = useCallback((index) => {
    setSucursalesSeleccionadas((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const handleSearch = useCallback((e) => {
    setSearchTerm(e.target.value.toLowerCase());
  }, []);

  const sucursalesFiltradas = useMemo(() => {
    return sucursalesSeleccionadas.filter((sucursal) =>
      `${sucursal.id} ${sucursal.nombre}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }, [sucursalesSeleccionadas, searchTerm]);

  const handleLimpiarYSeleccionarTodas = () => {
    const sucursalesNoDuplicadas = sucursales.filter(
      (sucursal, index, self) =>
        index === self.findIndex((e) => e.id === sucursal.id)
    );
    setSucursalesSeleccionadas(sucursalesNoDuplicadas);
  };

  console.log("sucursales", sucursales);
  console.log("fichas", fichas);

  const contarFichasPorSucursal = (sucursalId) => {
    if (!fichas) return 0;
    return fichas.filter((ficha) => ficha.sucursal === sucursalId).length;
  };

const enviarEmailsSucursales = async () => {
  setdisabled(true);
  try {
    // Validaciones básicas
    if (!fichas || fichas.length === 0) {
      setNotificacion({
        open: true,
        mensaje: "No hay fichas para enviar",
        severity: "warning",
      });
      setdisabled(false);
      return;
    }

    if (!sucursalesSeleccionadas || sucursalesSeleccionadas.length === 0) {
      setNotificacion({
        open: true,
        mensaje: "No hay sucursales seleccionadas",
        severity: "warning",
      });
      setdisabled(false);
      return;
    }

    setNotificacion({
      open: true,
      mensaje: "Preparando y enviando emails...",
      severity: "info",
    });

    // Contador de emails enviados
    let emailsEnviados = 0;

    // Procesar cada sucursal seleccionada
    for (const sucursal of sucursalesSeleccionadas) {
      // Filtrar fichas de esta sucursal
      const fichasSucursal = fichas.filter(f => f.sucursal === sucursal.id);
      
      // Si no hay fichas para esta sucursal, continuar con la siguiente
      if (fichasSucursal.length === 0) continue;

      // Si la sucursal no tiene email configurado, continuar con la siguiente
      if (!sucursal.mails || sucursal.mails.trim() === "") {
        console.warn(`Sucursal ${sucursal.nombre} no tiene email configurado`);
        continue;
      }

      try {
        // 1. Generar y enviar el ZIP por email usando el nuevo endpoint
        const response = await fetch(`${UrlApi}/generacionfichas/enviar-fichas-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            fichas: fichasSucursal,
            sucursal: {
              id: sucursal.id,
              nombre: sucursal.nombre,
              mails: sucursal.mails
            }
          })
        });

        const result = await response.json();

        if (!result.success) {
          throw new Error(result.message || "Error al enviar email");
        }

        emailsEnviados++;
        console.log(`Email con adjuntos enviado a ${sucursal.nombre}`);

      } catch (error) {
        console.error(`Error al enviar email a ${sucursal.nombre}:`, error.message || error);
      }
    }

    // Mostrar resultado final
    setNotificacion({
      open: true,
      mensaje: emailsEnviados > 0 
        ? `Se enviaron ${emailsEnviados} emails con adjuntos correctamente` 
        : "No se enviaron emails (no había destinatarios válidos o hubo errores)",
      severity: emailsEnviados > 0 ? "success" : "warning",
    });

  } catch (error) {
    console.error("Error general en enviarEmailsSucursales:", error);
    setNotificacion({
      open: true,
      mensaje: "Error en el proceso de envío: " + (error.message || "Error desconocido"),
      severity: "error",
    });
  } finally {
    setdisabled(false);
  }
};

useEffect(() => {
    obtenerFichas();
}, [desde, hasta]);

  return (
    <div>
      <Dialog
        open={props.open}
        // onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        {notificacion.open && (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => props.onClose(false)}
            severity={notificacion.severity}
          />
        )}
        <Box mt={1} backgroundColor={"#1F618D"}>
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Envio de Mail
            </Typography>
          </DialogTitle>
        </Box>
        <Box
          border={0.5}
          borderColor={grey[300]}
          backgroundColor="#F4F6F6"
          p={2}
          // py={2}
          mt={1}
        >
          {/* <DialogContent> */}
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              mb={1}
              alignContent={"center"}
              justifyContent={"center"}
              display={"flex"}
            >
              <Typography variant="h6">
                ¿Desea enviar las fichas de entrega de equipo a las sucursales?
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              alignContent={"center"}
              justifyContent={"center"}
              display={"flex"}
            >
              <Box>
                <TextField
                  sx={{ marginRight: 2 }}
                  focused
                  size="small"
                  label="Desde"
                  type="date"
                  value={desde}
                  onChange={(e) => setDesde(e.target.value)}
                />
                <TextField
                  sx={{ marginRight: 2 }}
                  type="date"
                  value={hasta}
                  onChange={(e) => setHasta(e.target.value)}
                  focused
                  size="small"
                  label="hasta"
                />
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={() => obtenerFichas()}
                  disabled={!desde || !hasta}
                >
                  Buscar
                </Button> */}
              </Box>
            </Grid>
            <Grid xs={8} mt={2}>
              {filtrando === true ? (
                <TextField
                  disabled
                  focused
                  fullWidth
                  size="small"
                  label="Actualizando..."
                />
              ) : (
                <Autocomplete
                  disabled={!sucursales}
                  required
                  disableClearable
                  id="sucursal"
                  style={style}
                  size="small"
                  noOptionsText={"Sucursal INEXISTENTE"}
                  options={sucursales.filter(
                    (sucursal) =>
                      !sucursalesSeleccionadas.some(
                        (selectedSucursal) =>
                          selectedSucursal.id === sucursal.id
                      )
                  )}
                  autoHighlight
                  getOptionLabel={(sucursal) =>
                    `${sucursal.id} - ${sucursal.nombre}`
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={sucursalSeleccionada || null}
                  onChange={(event, value) => {
                    setFiltrando(true);
                    handleSucursalSeleccionada(value);
                  }}
                  
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id} - {option.nombre}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Sucursal"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              )}
            </Grid>
            <Grid item xs={4} mt={1}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleLimpiarYSeleccionarTodas}
                fullWidth
              >
                Todas las Sucursales
              </Button>
            </Grid>

            <Grid item xs={12}>
              {sucursalesSeleccionadas.length > 0 ? (
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                    backgroundColor: "#f9f9f9",
                    maxHeight: "150px", // Altura máxima para mostrar tres líneas
                    overflowY: "auto", // Scroll vertical
                  }}
                >
                  <Grid container>
                    <Grid item xs={6} mb={1}>
                      <Typography
                        fontSize={18}
                        fontWeight="bold"
                        color="#1F618D"
                      >
                        Sucursales Seleccionadas:
                        <Typography component="span" sx={{ ml: 1, color: 'text.primary' }}>
      ({fichas ? fichas.length : 0} fichas totales)
    </Typography>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} mb={1}>
                      <TextField
                        fullWidth
                        size="small"
                        type="search"
                        placeholder="Buscar sucursal..."
                        value={searchTerm}
                        onChange={handleSearch}
                      />
                    </Grid>
                  </Grid>
                  <SucursalesSeleccionadasList
                    sucursalesFiltradas={sucursalesFiltradas}
                    handleEliminarSucursal={handleEliminarSucursal}
                    fichas={fichas} // Pasa las fichas como prop
                  />
                </Box>
              ) : (
                <Typography
                  fontSize={16}
                  color="gray"
                  justifyContent={"center"}
                  display={"flex"}
                >
                  No hay sucursales seleccionadas.
                </Typography>
              )}
            </Grid>
          </Grid>
          {/* </DialogContent> */}
          <DialogActions>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button
                variant="contained"
                onClick={() => props.onClose(false)}
                style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
              >
                Cancelar
              </Button>
              <Button
                //   style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                //   type="submit"
                variant="contained"
                color="success"
                onClick={enviarEmailsSucursales}
                disabled={!fichas || fichas.length === 0 || sucursalesSeleccionadas.length === 0 || disabled}
              >
                Enviar
              </Button>
            </Grid>
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
}

export default ModalEnviarPdf;
